module.exports = __webpack_public_path__ + "img/summary-price.4746c5e5.png";